import { LEADS_GET, LEADS_WARNING_MESSAGE } from '../actions/types';

const initialState = {
  leads: undefined,
  warning: {
    timestamp: undefined,
    message: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LEADS_GET._SUCCESS: {
      const { leads } = action.payload;
      state.leads = leads;
      return state;
    }
    case LEADS_WARNING_MESSAGE: {
      state.warning = {
        timestamp: Date.now(),
        message: action.payload,
      };
      return state;
    }
    default:
      return state;
  }
};

export { reducer as crm };
